import React from 'react';
import { ToastContainer } from 'react-toastify';

import { IToastProviderProps } from './types';

import 'react-toastify/dist/ReactToastify.css';
import './ToastProvider.scss';

export const ToastProvider: React.FC<IToastProviderProps> = ({ children }) => {
  return (
    <>
      {children}
      <ToastContainer
        newestOnTop
        closeOnClick
        pauseOnHover
        hideProgressBar
        position="top-right"
        autoClose={3000}
        theme="colored"
        limit={4}
      />
    </>
  );
};
